import axios from 'axios';
import { OCTOPUS_BASE_URL } from '.';
import { IDangerZone, IDangerZoneCreatePayload, IDangerZoneUpdatePayload } from '../types/danger-zone';
import { IApiResponse } from '../types/api-response';

export const getDangerZones = (params?: { limit?: number; skip?: number; country?: string }) => {
    const queryParams = new URLSearchParams();

    if (params?.limit) queryParams.append('limit', params.limit.toString());
    if (params?.skip) queryParams.append('skip', params.skip.toString());
    if (params?.country) queryParams.append('country', params.country);

    const queryString = queryParams.toString();
    const url = queryString ? `${OCTOPUS_BASE_URL}/danger-zones?${queryString}` : `${OCTOPUS_BASE_URL}/danger-zones`;

    return axios.get<IApiResponse<IDangerZone[]>>(url);
};

export const createDangerZone = (data: IDangerZoneCreatePayload) => axios.post<IApiResponse<IDangerZone>>(`${OCTOPUS_BASE_URL}/danger-zones`, data);

export const updateDangerZone = (
    id: string,
    data: IDangerZoneUpdatePayload,
) => axios.put<IApiResponse<IDangerZone>>(`${OCTOPUS_BASE_URL}/danger-zones/${id}`, data);

export const deleteDangerZone = (id: string) => axios.delete<IApiResponse<void>>(`${OCTOPUS_BASE_URL}/danger-zones/${id}`);
